import { v4 as uuidv4 } from 'uuid'

export const publishTap2PayConnectionTokenCreatedMessage = (connectionToken, isDev, accountDetails) => {
	if (!window.ReactNativeWebView) {
		return false
	}
	const message = {
		eventId: uuidv4(),
		traceId: uuidv4(),
		type: 'kassa-web.TAP_TO_PAY_CONNECTION_TOKEN_CREATED',
		context: 'kassa-web',
		eventTime: new Date().toISOString(),
		data: { connectionToken, isDev, accountDetails },
	}
	window.ReactNativeWebView.postMessage(JSON.stringify(message))
	return true
}
